import React, { useEffect, useRef, useState } from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import LayoutComposer from '../LayoutComposer';

import css from './LayoutSingleColumn.module.css';
import { compose } from 'redux';
import { withViewport } from '../../../util/uiHelpers';

// Commonly used layout
const LayoutSingleColumnComponent = props => {
  const {
    className,
    rootClassName,
    mainColumnClassName,
    isLayoutWithoutFooter,
    viewport,
    children,
    topbar: topbarContent,
    footer: footerContent,
    ...rest
  } = props;
  const isMobileLayout = viewport?.width > 0 && viewport?.width < 1024;
  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      if (footerRef.current) {
        setFooterHeight(footerRef.current.offsetHeight);
      }
    };

    updateHeight(); // initial load
    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, []);
  const classes = classNames(
    rootClassName || css.root,
    className,
    isLayoutWithoutFooter ? css.layoutWithoutFooter : null
  );
  const layoutAreas = `
    topbar
    main
    footer
  `;
  return (
    <LayoutComposer
      areas={layoutAreas}
      className={classes}
      // style={{ paddingBottom: isMobileLayout ? null : footerHeight }}
      {...rest}
    >
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={css.topbar}>
              {topbarContent}
            </Topbar>
            <Main as="main" className={classNames(css.main, mainColumnClassName)}>
              {children}
            </Main>
            <Footer className={css.footer} ref={footerRef}>
              {footerContent}
            </Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

LayoutSingleColumnComponent.displayName = 'LayoutSingleColumn';

LayoutSingleColumnComponent.defaultProps = {
  className: null,
  rootClassName: null,
  footer: null,
};

LayoutSingleColumnComponent.propTypes = {
  className: string,
  rootClassName: string,
  children: node.isRequired,
  topbar: node.isRequired,
  footer: node,
};

const LayoutSingleColumn = compose(withViewport)(LayoutSingleColumnComponent);

export default LayoutSingleColumn;
